export default __webpack_public_path__ + "streamline-operations.245ad4fe.svg";